export const FIELD_ID_KEY = "id";
export const FIELD_SUBTEMPLATE_KEY = "subtemplate_key";
export const FIELD_METADATA_KEY = "metadata";
export const FIELD_CUSTOM_FIELDS_KEY = "custom_fields";
export const FIELD_NAME_KEY = "name";
export const FIELD_DESCRIPTION_KEY = "description";
export const FIELD_POST_UNTIL_KEY = "post_until";
export const FIELD_POST_UNTIL_CHANGE_REASON_KEY = "post_until_change_reason";
export const FIELD_MIN_REQUIRED_COUNT_KEY = "min_required_count";
export const FIELD_BOOKING_CATEGORY_ID_KEY = "booking_category_id";
export const FIELD_PARENT_ACTIVITY_KEY = "parent_activity";
export const FIELD_PARENT_ACTIVITY_ID_KEY = "parent_activity_id";
export const FIELD_ASSIGNEE_ID_KEY = "assignee_id";
export const FIELD_DEVELOPMENTAL_KEY = "developmental";
export const FIELD_SKILLS_KEY = `${FIELD_CUSTOM_FIELDS_KEY}.skills`;
export const FIELD_AVAILABILITY_KEY = `${FIELD_METADATA_KEY}.availability`;
export const FIELD_AVAILABILITY_MODE_KEY = `${FIELD_AVAILABILITY_KEY}.mode`;
export const FIELD_AVAILABILITY_THRESHOLD_KEY = `${FIELD_AVAILABILITY_KEY}.availability_threshold`;
export const FIELD_AVAILABILITY_RANGES_KEY = `${FIELD_AVAILABILITY_KEY}.ranges`;
export const FIELD_PRIVACY_KEY = "private";
export const FIELD_AUDIENCES_KEY = "audiences";
export const FIELD_ATTACHMENT_IDS_KEY = "attachment_ids";
export const FIELD_INTEREST_QUESTIONS_KEY = "interest_questions";
export const FIELD_INTEREST_STATEMENT_ENABLED_KEY = "interest_statement_enabled";
export const FIELD_INTEREST_QUESTIONS_TOGGLE_KEY = "interest_questions_toggle"; // do not submit in form
export const FIELD_COMMUNICATION_TYPE_KEY = "communication_type";
export const FIELD_SKILLS_FRAMEWORK_IDS_KEY = "skills_framework_ids";
export const FIELD_TEMPLATE_ID_KEY = "template_id";
export const FIELD_MARKED_FOR_REMOVAL_KEY = "markedForRemoval";
export const FIELD_STATE_KEY = "state";
export const FIELD_UNIQUE_ID_KEY = "uniqueId";
export const FIELD_CONVERTED_AVAILABILITY_KEY = "convertedAvailability";
export const FIELD_CONVERTED_AVAILABILITY_RANGES_KEY = "convertedAvailability.ranges";

export const FORM_SUBTEMPLATES_KEY = "subtemplates";
export const FORM_ROLES_KEY = "roles";

export const NO_SUBTEMPLATE_VALUE = "no_subtemplate";
